<template>
  <div class="main">
    <div class="main_left">
      <div class="main_left_box">
        <div class="main_left_box1_top">
          <img
            src="../assets/icon/组 114.png"
            alt=""
          >
          <span>中心平台概括</span>
        </div>
        <div class="main_left_box1_body">
          <Table
            :columns="columns1"
            :data="SumData"
          ></Table>
        </div>
      </div>
      <div class="main_left_box">
        <div class="main_left_box1_top">
          <img
            src="../assets/icon/组 114.png"
            alt=""
          >
          <span>今日统计</span>
        </div>
        <div class="main_left_box1_body">
          <Table
            :columns="columns2"
            :data="SumData"
          ></Table>
        </div>
      </div>
      <div class="main_left_box2">
        <div class="main_left_box2_top">
          <img
            src="../assets/icon/组 114.png"
            alt=""
          >
          <span>实验统计</span>
        </div>
        <div class="main_left_box2_body">
          <div
            id="experCharts"
            style="width:100%;height:100%"
          >
          </div>
        </div>
      </div>
    </div>
    <div class="main_right">
      <div class="main_right_box">
        <div class="main_right_box_top">
          <img
            src="../assets/icon/组 114.png"
            alt=""
          >
          <span>使用设备统计</span>
        </div>
        <div class="main_right_box_contend">
          <div
            id="equipment"
            style="width:100%;height:100%"
          >
          </div>
        </div>
      </div>
      <div class="main_right_box">
        <div class="main_right_box_top">
          <img
            src="../assets/icon/组 114.png"
            alt=""
          >
          <span>实验分类统计</span>
        </div>
        <div class="main_right_box_contend">
          <div
            id="expClasssify"
            style="width:100%;height:100%"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import Api from '../api/index'
import _ from 'lodash'

export default {
  data () {
    return {
      equipmentOption: {
        title: {
          // text: '某站点用户访问来源',
          // subtext: '纯属虚构',
          // left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // legend: {
        //   orient: 'vertical',
        //   bottom: 'bottom',
        //   bottom: '20',
        // },
        color: ['#5B9BD5', '#FFC000', '#ED7D31'],
        series: [
          {
            name: '设备名称',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      expTypeOption: {
        title: {
          // text: '某站点用户访问来源',
          // subtext: '纯属虚构',
          // left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // legend: {
        //   // orient: 'vertical',
        //   bottom: 'bottom',
        //   bottom: '0',
        // },
        color: ['#5B9BD5', '#FFC000', '#ED7D31'],
        series: [
          {
            name: '实验名称',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      experOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} '
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          name: '次数',
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          left: '9%',
          bottom: -5,
          start: 0,
          end: 100 //初始化滚动条
        }],
        grid: {
          top: '13%',
          right: '5%',
          left: '5%',
          containLabel: true
        },
        series: [
          {
            name: '实验名称',
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ['#FF8C00', '#EE3B3B', '#CDCD00', '#29AAE3',
                    '#0AAF9F']
                  return colorList[params.dataIndex % colorList.length]
                },
              }
            }
          }]
      },
      columns1: [
        {
          title: '实验个数',
          key: 'expercount',
          align: 'center'
        },
        {
          title: '课程数量',
          key: 'coursecount',
          align: 'center'
        },
        {
          title: '课程评论数',
          key: 'commentcount',
          align: 'center'
        },
        {
          title: '专业个数',
          key: 'speccount',
          align: 'center'
        },
        {
          title: '班级个数',
          key: 'classcount',
          align: 'center'
        },
        {
          title: '学生总人数',
          key: 'stucount',
          align: 'center'
        },
        {
          title: '题库试题数量',
          key: 'questioncount',
          align: 'center'
        },
        {
          title: '试题考核数量',
          key: 'quescheckcount',
          align: 'center'
        },
        {
          title: '操作考核数量',
          key: 'expercheckcount',
          align: 'center'
        },
      ],
      columns2: [
        {
          title: '登录人次',
          key: 'todaylogcount',
          align: 'center'
        },
        {
          title: '理论课学习人数',
          key: 'todaystudycount',
          align: 'center'
        },
        {
          title: '理论课评论人数',
          key: 'todaycommentcount',
          align: 'center'
        },
        {
          title: '参与实验人数',
          key: 'todayexpercount',
          align: 'center'
        },
        {
          title: '参与实验次数',
          key: 'todayexpercount',
          align: 'center'
        },
        {
          title: '试题练习人数',
          key: 'todayquesusercount',
          align: 'center'
        },
        {
          title: '试题考核人数',
          key: 'todaycheckusercount',
          align: 'center'
        },
        {
          title: '试题考核次数',
          key: 'todaycheckcount',
          align: 'center'
        },
      ],
      theoryRandList: [],
      classId: '',
      theoryRandTable: [
        {
          title: '操作次数',
          key: 'operatecount',
          align: 'center'
        },
        {
          title: '最高时长',
          key: 'maxusedtime',
          align: 'center'
        },
        {
          title: '最低时长',
          key: 'minusedtime',
          align: 'center'
        },
        {
          title: '平均时长',
          key: 'avgusedtime',
          align: 'center'
        },
        {
          title: '总次数',
          key: 'allcount',
          align: 'center'
        },
        {
          title: '操作人次',
          key: 'usercount',
          align: 'center'
        },
        {
          title: '成功率',
          key: 'successrate',
          align: 'center'
        },
      ],
      theoryRandTableData: [],
      SumData: [],
      experParams: {
        experimentid: '',
        classid: '',
      },
      classList: [],
      experTreeList: [],
      setTableColum: [
        {
          title: '步骤名称',
          key: 'itemname',
          align: 'center'
        },
        {
          title: '操作次数',
          key: 'allcount',
          align: 'center'
        },
        {
          title: '最高时长',
          key: 'maxtime',
          align: 'center'
        },
        {
          title: '最低时长',
          key: 'mintime',
          align: 'center'
        },
        {
          title: '平均时长',
          key: 'avgtime',
          align: 'center'
        },
      ],
      setTableData: [],
      experimentid: '',
    }
  },
  created () {
    this.GetSumData()
    this.GetExperSumData()
    this.GetStepSumData()
  },
  async mounted () {
    // const that = this
    this.GetChartSumData()
    this.GetChartSumData2()
    this.GetHomeExperDataChart()
    // this.$nextTick(function () {
    //   setTimeout(function () {
    //     that.renderChart(that.equipmentOption, 'equipment')
    //     that.renderChart(that.expTypeOption, 'expClasssify')
    //     that.renderChart(that.experOption, 'experCharts')
    //     that.GetSumData()
    //   }, 1000)
    // });
  },
  methods: {
    //获取平台统计概况
    async GetSumData () {
      const res = await Api.sum.GetSumData()
      if (res.success != true) return this.$message.info(res.msg)
      this.SumData.push(res.rows)
    },
    //根据实验类型或设备统计图数据
    async GetChartSumData () {
      const res = await Api.sum.GetChartSumData(0)
      this.equipmentOption.series[0].data = res.rows
      this.renderChart(this.equipmentOption, 'equipment')
    },
    async GetChartSumData2 () {
      const req = await Api.sum.GetChartSumData(1)
      this.expTypeOption.series[0].data = req.rows
      this.renderChart(this.expTypeOption, 'expClasssify')
    },
    //获取系室专业班级树形图
    async GetOrgDataTree () {
      const res = await Api.organization.GetOrgDataTree()
      this.classList = res.rows
    },
    //获取实验树形结构
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experTreeList = res.rows
    },
    //根据班级筛选实验统计
    classIdChange (e) {
      this.experParams.classid = e
      this.GetExperSumData()
    },
    //根据实验id筛选实验统计
    experIdChange (e) {
      this.experParams.experimentid = e
      this.GetExperSumData()
    },
    //实验统计数据
    async GetExperSumData () {
      this.GetExperTree()
      this.GetOrgDataTree()
      const res = await Api.sum.GetExperSumData(this.experParams)
      this.theoryRandTableData.push(res.rows)
    },
    //获取实验步骤情况
    async GetStepSumData () {
      const res = await Api.sum.GetStepSumData(this.experimentid)
      this.setTableData.push(res.rows)
    },
    //根据实验id筛选实验步骤
    setIdChange (e) {
      this.experimentid = e
      this.GetStepSumData()
    },

    renderChart (option, dom) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById(dom))
      myChart.setOption(option)
    },
    //实验统计柱状图
    async GetHomeExperDataChart () {
      const res = await Api.sum.GetHomeExperDataChart()
      if (res.success != true) return this.$message.info(res.msg)
      let expername = []
      let expernum = []
      for (let index = 0; index < res.rows.length; index++) {
        const element = res.rows[index];
        expername.push(element.experimentname)
        expernum.push(element.operatecount)
      }
      this.experOption.xAxis.data = expername
      this.experOption.series[0].data = expernum
      this.renderChart(this.experOption, 'experCharts')
    },

  }
}
</script>
<style lang='less' scoped>
.main {
  .main_left {
    display: inline-block;
    width: 73%;
    .main_left_box {
      padding: 0 0 20px 0;
      margin-bottom: 20px;
      background-color: #ffffff;
      box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      .main_left_box1_top {
        width: 100%;
        height: 44px;
        margin-bottom: 5px;
        border-bottom: 1px solid #c7ebf3;
        font-size: 16px;
        padding: 10px 24px;
        img {
          vertical-align: middle;
        }
        span {
          margin-left: 8px;
          color: #567eaf;
        }
      }
    }
    .main_left_box2 {
      width: auto;
      margin-bottom: 20px;
      height: 370px;
      border-radius: 10px;
      background-color: #ffffff;
      .main_left_box2_top {
        width: 100%;
        height: 44px;
        margin-bottom: 5px;
        border-bottom: 1px solid #c7ebf3;
        font-size: 16px;
        padding: 10px 24px;
        img {
          vertical-align: middle;
        }
        span {
          margin-left: 8px;
          color: #567eaf;
        }
      }
      .main_left_box2_body {
        height: 85%;
      }
    }
    .main_left_box:nth-child(1),
    .main_left_box:nth-child(2) {
      height: 180px;
      .main_left_box1_body {
        padding-top: 20px;
      }
    }
  }
  .main_right {
    float: right;
    width: 25%;
    .main_right_box {
      height: 380px;
      background-color: #ffffff;
      box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      margin-bottom: 13px;
      .main_right_box_top {
        width: 100%;
        height: 44px;
        border-bottom: 1px solid #c7ebf3;
        font-size: 16px;
        padding: 10px 24px;
        img {
          vertical-align: middle;
        }
        span {
          margin-left: 8px;
          color: #567eaf;
        }
        button {
          margin-top: -5px;
          padding: 0;
        }
      }
      .main_right_box_contend {
        height: 90%;
      }
    }
  }
  /deep/.el-input__inner {
    height: 30px;
    margin-left: 10px;
  }
}
</style>